<app-onboarding-checklist (setUpApt)="setUpApt()" (setUpRo)="setUpRo()" (setUpInvite)="setUpInvite()"
  *ngIf="companyType === 'GUIDED_TRIALS'">
</app-onboarding-checklist>

<!-- Lock screen -->
<div class="lockScreen" (click)="disableApt()"
  [ngClass]="{'d-block': enableAptDropdown || enableRoDropdown || enableInvite}">
</div>

<!-- Class to be add after enabling the Onboarding Checklist Component '.top-bar' -->
<app-header [navs]="navItems" (disableApt)="disableApt()"
  [ngClass]="{'top-bar': companyType === 'GUIDED_TRIALS', 'enable-apt': enableAptDropdown, 'enable-ro': enableRoDropdown, 'enable-invite': enableInvite}">
</app-header>

<!-- Class to be add after enabling the Onboarding Checklist Component '.top-appt' -->
<div class="app-body mt-58" [ngClass]="{'top-appt': companyType === 'GUIDED_TRIALS'}">
  <main class="main">
    <router-outlet></router-outlet>

    <div *ngIf="isAppleDevice" class="height-200"></div>
  </main>
</div>

<app-toaster></app-toaster>
